// @flow
import React from 'react'
import numeral from 'numeral'
import PRStatusBadge from '../../../pull_request/PRStatusBadge'

type Props = {
  prStatus: string,
  issuesDiff: string
}

export default class MetaData extends React.Component<Props> {
  render () {
    return (
      <div className='flex-row'>
        <PRStatusBadge status={this.props.prStatus} borderRadius='0px' marginLeft='0px' />
        <span style={{marginLeft: 10}}>
          <strong>{numeral(this.props.issuesDiff).format('+0')}&nbsp;</strong>
          issue count
        </span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/components/project_dashboard/PRList/PRListItem/MetaData.js